export const Footer = () => {
  return(
    <footer>
      <div className="text-center py-4 text-black-50 mt-5 bg-light">
        ©2021 fueri
      </div>
    </footer>
  )
};
